import { render, staticRenderFns } from "./sale-banner.vue?vue&type=template&id=4aeba0f2&scoped=true&"
import script from "./sale-banner.vue?vue&type=script&lang=js&"
export * from "./sale-banner.vue?vue&type=script&lang=js&"
import style0 from "./sale-banner.vue?vue&type=style&index=0&id=4aeba0f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aeba0f2",
  null
  
)

export default component.exports